<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="寄回人真实姓名" prop="returnRelname" >
        <a-input v-model="form.returnRelname" placeholder="请输入寄回人真实姓名" />
      </a-form-model-item>
      <a-form-model-item label="寄回人联系方式" prop="returnPhone" >
        <a-input :maxLength="11" v-model="form.returnPhone" placeholder="请输入寄回人联系方式" />
      </a-form-model-item>
      <a-form-model-item label="寄回地址" prop="returnAddress" >
        <a-input v-model="form.returnAddress" placeholder="请输入寄回地址" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort" >
        <a-input-number :min="0" style="width: 300px" v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAddress, addAddress, updateAddress } from '@/api/refund/address'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        returnRelname: null,

        returnPhone: null,

        returnAddress: null,

        sort: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        returnRelname: [
          { required: true, message: '寄回人真实姓名不能为空', trigger: 'blur' }
        ],
        returnPhone: [
          { required: true, message: '寄回人联系方式不能为空', trigger: 'blur' }
        ],
        returnAddress: [
          { required: true, message: '寄回地址不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.reset()
      this.open = false

    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        returnRelname: null,
        returnPhone: null,
        returnAddress: null,
        sort: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.open = true
      this.reset()
      this.formType = 1

      this.formTitle = '添加'
    },

    validatePhone(phoneNumber) {
      const regex = /^1[3-9]\d{9}$/;
      return regex.test(phoneNumber);
    },

    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.open = true
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAddress({"id":id}).then(response => {
        this.form = response.data
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.validatePhone(this.form.returnPhone) == false){
            this.$message.error("手机号格式有误")
            return
          }
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAddress(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAddress(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
